export const init = () => {
  /*
  *** Describe: It´s filter, which can work with single select box if you describe select target, items target and it´s data-filter attribute. 
  @eventType: onChange [String] | click: TODO - easy-medium level
  @preselectedValue: [Number] 
  @splider: [object] It can work with splider | functionallity without splider: TODO - easy level
*/

  // Example of calling function: 
  // filterSingleSelectByNumber({
  //   type: "spliderOnChange",
  //   //preselectedValue: 3,
  //   splider: {
  //     id: splidecarousel11,
  //     Controller,
  //     arrowLeft, 
  //     arrowRight 
  //   },
  // });
}

export function filterSingleSelectByNumber({ type = "spliderOnChange", splider, preselectedValue = "" }) {
  const filterWrapper = document.querySelectorAll(".js-filter-by-number");
  if (!filterWrapper) return;

  /* MAIN LOGIC */
  filterWrapper.forEach((filter) => {
    const filterSelectBox = filter.querySelector(".js-filter-select");
    const filterTargetArea = filter.querySelector(".js-filter-target");
    const filterSingleItemsArr = filterTargetArea.querySelectorAll('[data-filter]');

    if (preselectedValue) filterSelectBox.value = preselectedValue;

    switch (type) {
      case 'spliderOnChange':
        filteringWithSplider(splider, filterSelectBox, filterSingleItemsArr);
        filterSelectBox.addEventListener("change", () => {
          filteringWithSplider(splider, filterSelectBox, filterSingleItemsArr);
        });
        break;
      case 'spliderOnClick':
        // TODO
        break
      case 'justOnClick':
        // TODO
        break
    }
  });
}

// HELPERS 
function filteringWithSplider(splider, filterSelectBox, filterSingleItemsArr) {
  const filterSingleItemsArrCopy = Array.from(filterSingleItemsArr);
  let filterSingleItemData = [];
  let getSelectedOption = "";

  getSelectedOption = String(filterSelectBox.value);
  if (getSelectedOption === "all") getSelectedOption = 0;

  splider.Controller.go(0);

  filterSingleItemsArrCopy.forEach((filterSingleItem) => {
    filterSingleItemData = filterSingleItem.dataset.filter.split(",");
    if (!filterSingleItemData.includes(getSelectedOption) && getSelectedOption !== 0) {
      filterSingleItem.remove();
    } else {
      splider.id.add(filterSingleItem);
    }
  });

  splider.id.refresh();






}